<template lang="pug">
  v-row(no-gutters)
    v-btn-toggle(mandatory v-model="isCommerce" class="toggle-buttons")
      v-row(no-gutters)
        v-btn(
          v-for="item in types"
          :key="item.id"
          :value="item.value")
          v-col(class="flex-wrap")
            img(
              :src="require(`@/assets/images/icons/advert/${item.value === isCommerce ? item.activeIcon : item.icon}.svg`)",
              :alt="`${item.icon} icon`")
            div(class="v-btn-title") {{ item.title }}
</template>

<script>
export default {
  name: 'Commerce',
  data: () => ({
    types: [
      {
        id: '1',
        title: 'Коммерческое',
        value: true,
        icon: 'commerce',
        activeIcon: 'commerce_active'
      },
      {
        id: '2',
        title: 'Частное',
        value: false,
        icon: 'personal',
        activeIcon: 'personal_active'
      }
    ],
    isCommerce: false
  }),
  watch: {
    isCommerce: {
      immediate: true,
      handler(value) {
        this.$emit('set-commerce-type', value)
      }
    }
  }
}
</script>
